import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SvgAttribute } from "@/shared/constants/constants";

import { AdminWalletHistoryResponse } from "@/shared/repository/modules/wallet/repo";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    row: {
      type: <PropType<AdminWalletHistoryResponse>>Object,
      required: true,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    displayedIcons(): SvgAttribute {
      return SVG;
    },
  },
  methods: {
    handleToggle(): void {
      this.isVisible = !this.isVisible;
    },

    handleHide(): void {
      this.isVisible = false;
    },

    getWallet(row: AdminWalletHistoryResponse): string {
      if (row.type === "withdrawal") {
        const tag = row.tag ? row.tag : "";
        return row.address + " " + tag + " (" + row.chain + ")";
      }
      if (row.type === "exchange") {
        return "Fee: " + row.address;
      }
      return row.address;
    },

    getMessage(row: AdminWalletHistoryResponse): string {
      if (row.status === "success") {
        if (row.type === "exchange") {
          return "Symbol: " + row.tag + " Side: " + row.chain;
        }
      }
      return row.message || "No message";
    },

    getAmount(row: AdminWalletHistoryResponse): string {
      return +row.amount + " " + row.coin;
    },
  },
});
